// src/components/User/Home/HomePage/WhatFoundersSaySection.js
import React from "react";
import { Quote } from "lucide-react";

export default function WhatFoundersSaySection() {
    const items = [
        "People try us once and don't come back, and I can't see where in the journey we're losing them.",
        "I know we're losing money to referral or offer abuse, but I don't know how to stop it.",
        "We want to reward our best customers, but I don't actually know who they are.",
        "We want to run real experiments but don't know how.",
        "We want to launch a new category, but I don't know where the real gap is."
    ];

    return (
        <section
            id="what-founders-say"
            className="px-6 md:px-12 lg:px-24 py-8"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[900px]">
                <div
                    className="rounded-2xl p-6 sm:p-8"
                    style={{
                        backgroundColor: "#f5f4ef",
                        border: "1px solid rgba(26,30,46,0.06)",
                    }}
                >
                    <p
                        className="text-base sm:text-lg mb-8 max-w-[520px] font-normal leading-relaxed"
                        style={{ color: "#6b6a63" }}
                    >
                        These are the conversations I actually have with founders, usually before they've put a name to the problem.
                    </p>

                    <div className="flex flex-col">
                        {items.map((text, idx) => (
                            <div
                                key={idx}
                                className="flex gap-4 py-4 border-t"
                                style={{
                                    borderColor: "#ddd9cc",
                                    borderBottom: idx === items.length - 1 ? "1px solid #ddd9cc" : "none"
                                }}
                            >
                                <Quote
                                    size={20}
                                    className="flex-shrink-0 mt-[3px]"
                                    style={{ color: "var(--color-primary)" }}
                                />
                                <p
                                    className="text-base lg:text-[17px] leading-relaxed font-normal"
                                    style={{ color: "#1c1b18" }}
                                >
                                    {text}
                                </p>
                            </div>
                        ))}
                    </div>

                    <p
                        className="text-base sm:text-lg font-medium text-left mt-8"
                        style={{ color: "#1c1b18" }}
                    >
                        Recognize one? That's usually where we start.
                    </p>
                </div>
            </div>
        </section>
    );
}
